import { AbsenceCalendarType } from '@lmt/unicorn-shared/app/components/absences/common/types';
import { ReactComponent as LeftArrow } from '@lmt/unicorn-shared/app/icons/arrow-left.svg';
import { ReactComponent as RightArrow } from '@lmt/unicorn-shared/app/icons/arrow-right.svg';
import { localFormat } from '@lmt/unicorn-shared/app/helpers/date-helper';
import styles from '@lmt/unicorn-shared/src/app/components/absences/AbsenceDatePicker.module.scss';
import { addYears, addMonths } from 'date-fns';
import React, { FC, useMemo } from 'react';
import { useEventCallback } from '@mui/material';

interface Props {
  currentDate: Date;
  setCurrentDate: (date: Date) => void;
  calendarType: AbsenceCalendarType;
}

const minDate = new Date(1900, 0);
const maxDate = new Date(2100, 0);

export const AbsenceDatePicker: FC<Props> = React.memo((props) => {
  const { currentDate, setCurrentDate, calendarType } = props;

  const setDate = useEventCallback((date: Date) => {
    if (date < minDate || date > maxDate) {
      return;
    }
    setCurrentDate(date);
  });

  const addValueToDate = useEventCallback((amount: number) => {
    if (calendarType === AbsenceCalendarType.Year) {
      setDate(addYears(currentDate, amount));
      return;
    }
    if (calendarType === AbsenceCalendarType.Month) {
      setDate(addMonths(currentDate, amount));
      return;
    }
    throw new Error(`Unknown calendar type ${calendarType}`);
  });

  const formattedCurrentDate = useMemo(() => {
    return localFormat(
      currentDate,
      calendarType === AbsenceCalendarType.Year ? 'yyyy' : 'LLLL yyyy',
    );
  }, [currentDate, calendarType]);

  return (
    <div className={styles.container}>
      <div className={styles.arrows}>
        <div
          className={styles.arrowContainer}
          onClick={() => addValueToDate(-1)}
        >
          <LeftArrow className={styles.arrowIcon} />
        </div>
        <div
          className={styles.arrowContainer}
          onClick={() => addValueToDate(1)}
        >
          <RightArrow className={styles.arrowIcon} />
        </div>
      </div>
      <span className={styles.title}>{formattedCurrentDate}</span>
    </div>
  );
});
